import { Flex, Switch } from '@radix-ui/themes';
import { CommonInputHint } from 'components/common/form/hint';
import { CommonInputLabel } from 'components/common/form/label';
import { CommonInputWrapper } from 'components/common/form/wrapper';
import { ISwitchInput } from 'interfaces/forms/switch';
import { RADIX } from 'lib_ts/enums/radix-ui';

export const CommonSwitchInput = (props: ISwitchInput) => {
  const switchNode = (
    <Switch
      name={props.name}
      size={props.size}
      disabled={props.disabled}
      checked={props.checked}
      defaultChecked={props.defaultChecked}
      color={props.inputColor}
      onCheckedChange={(checked) => props.onCheckedChange?.(checked)}
    />
  );

  return (
    <CommonInputWrapper {...props}>
      <Flex
        gap={RADIX.FLEX.GAP.INPUT}
        align="center"
        justify={props.justify ? 'between' : undefined}
      >
        {!props.reverse && switchNode}
        <CommonInputLabel {...props} />
        {props.reverse && switchNode}
      </Flex>

      <CommonInputHint {...props} />
    </CommonInputWrapper>
  );
};
